export default __webpack_public_path__ + "static/xr_glasses-38d043a64591b29f73857db8488e713c.png";